var render = function () {
  var _vm$preorderSetting$t;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "PreorderSettingList",
      "extra-items": [{
        text: (_vm$preorderSetting$t = _vm.preorderSetting.title) !== null && _vm$preorderSetting$t !== void 0 ? _vm$preorderSetting$t : ''
      }, '預購單列表']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-4 mb-2 font-weight-bold"
  }, [_vm._v(" 預購單列表 "), _c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "inverse-dark"
    },
    on: {
      "click": _vm.showFormUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })])], 1), _c('b-input-group', {
    staticClass: "col-12 col-xl-8 mb-4",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_vm.branchSelectIsEnabled ? _c('AppSingleSelect', {
    staticClass: "mr-2 mb-2 mb-xl-0",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "options": _vm.branchFilterOptions,
      "placeholder": _vm.preorderSetting.config.branch_select.default_select_text,
      "clearable": false
    },
    on: {
      "input": _vm.handleBranchChange
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("請選擇訂單櫃點")])];
      },
      proxy: true
    }], null, false, 3626405531),
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  }) : _vm._e(), _c('b-dropdown', {
    staticClass: "mr-2",
    attrs: {
      "text": "匯出",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.listExport
    }
  }, [_vm._v("清單匯出")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.detailExport
    }
  }, [_vm._v("明細匯出")])], 1), _c('b-form-input', {
    staticClass: "col-xl-3",
    attrs: {
      "placeholder": "搜尋"
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" 進階搜尋"), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1)], 1), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', {}, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "建立日期",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "disabledEndAtDates": _vm.disabledEndAtDates,
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間"
    },
    on: {
      "update:disabledEndAtDates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "update:disabled-end-at-dates": function updateDisabledEndAtDates($event) {
        _vm.disabledEndAtDates = $event;
      },
      "input": _vm.handleDateChange
    },
    model: {
      value: _vm.query,
      callback: function callback($$v) {
        _vm.query = $$v;
      },
      expression: "query"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "訂單狀態",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.statusOptions
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("請選擇")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "訂購人名稱",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "訂購人名稱"
    },
    model: {
      value: _vm.query.name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "name", $$v);
      },
      expression: "query.name"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "訂購人手機",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "訂購人手機"
    },
    model: {
      value: _vm.query.mobile,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "mobile", $$v);
      },
      expression: "query.mobile"
    }
  })], 1)], 1), _c('div', {
    staticClass: "flex-column"
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置條件")]), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.preorders,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(customer_name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.customer ? data.item.customer.name : "無") + " ")];
      }
    }, _vm._l(_vm.visibleDynamicFormFields, function (field) {
      return {
        key: "cell(".concat(field.key, ")"),
        fn: function fn(data) {
          return [_vm._v(" " + _vm._s(data.field.value(data.item)) + " ")];
        }
      };
    }), {
      key: "cell(preorder_setting_title)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.preorderSetting ? data.item.preorderSetting.title : "無") + " ")];
      }
    }, {
      key: "cell(branch_name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.branch ? data.item.branch.name : "無") + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.displayStatusText(data.item.status)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'PreorderDetail',
              params: {
                id: _vm.preorderSettingId,
                preorder_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 查看訂單 ")]), _vm.checkPermission([_vm.consts.PREORDER_DELETE]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deletePreorder(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }], null, true)
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "form-url-modal",
      "footer-class": "d-flex justify-content-center"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', {
          staticClass: "m-0 align-self-center"
        }, [_vm._v(_vm._s(_vm.preorderSetting.title))]), _c('b-button', {
          staticClass: "text-dark",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('svg', {
          staticStyle: {
            "height": "20px"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 320 512"
          }
        }, [_c('path', {
          attrs: {
            "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
          }
        })])])];
      }
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "modal-button-group"
        }, [_c('b-button', {
          staticClass: "center-button",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.downloadQRCode(_vm.preorderSetting.title);
            }
          }
        }, [_vm._v(" 下載QRCode ")]), _c('b-button', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('form-url-modal');
            }
          }
        }, [_vm._v(" 關閉 ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v("預購網址")]), _c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    attrs: {
      "id": "form-url"
    },
    on: {
      "click": function click($event) {
        return _vm.copyFormUrl('#form-url');
      }
    },
    model: {
      value: _vm.formUrl,
      callback: function callback($$v) {
        _vm.formUrl = $$v;
      },
      expression: "formUrl"
    }
  }), _c('div', [_c('vue-qr', {
    ref: "qrcode",
    attrs: {
      "text": _vm.formUrl
    }
  })], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }